import type {MouseEvent, ReactElement} from 'react';
import React from 'react';
import {Icon} from '@Components/icon-v2';
import {IconShape, IconSize, IconType} from '@Components/icon-v2/icon.types';

interface PlayPauseButtonProps {
  isPlaying: boolean;
  onPause(e: MouseEvent): void;
  onPlay(e: MouseEvent): void;
  iconSize: IconSize;
  className?: string;
  iconShape?: IconShape;
  iconType?: IconType;

  currentTime?: number;
  totalDuration?: number;
}

export function PlayPauseButton({iconSize = IconSize.SIZE_ICON_20, iconShape = IconShape.SQUARE, iconType = IconType.GHOST, ...props}: PlayPauseButtonProps): ReactElement<any> {
  const onPlay = (e: React.MouseEvent): void => {
    props.onPlay(e);
  };

  const onPause = (e: React.MouseEvent): void => {
    props.onPause(e);
  };

  const onClickHandler = (e: React.MouseEvent): void => {
    if (props.isPlaying) {
      onPause(e);
    } else {
      onPlay(e);
    }
  };

  const getIcon = (): string => {
    if (props.currentTime && props.totalDuration && props.currentTime === props.totalDuration) {
      return 'icon-replay-video';
    }

    return props.isPlaying ? 'icon-pause' : 'icon-play-video';
  };

  return <Icon className={props.className} onClick={onClickHandler} icon={getIcon()} size={iconSize} type={iconType} shape={iconShape} />;
}
